<template>
  <div class="content">
    <div class="header">
      <div style="margin: 5px 0">
        <div>
          <SelectCdjProjectHeader @onHeader="onHeader">
            <div class="search-form" v-show="activeTab === 'list'">
              <div class="search-row">
                <div class="search-item">
                  <span class="search-label">业户类型：</span>
                  <el-select v-model="where.identity" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="业主" value="1"></el-option>
                    <el-option label="租户" value="2"></el-option>
                    <el-option label="住户" value="3"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">是否真实业户：</span>
                  <el-select v-model="where.is_effective" size="mini" clearable placeholder="请选择" style="width: 100px">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">缴费记录：</span>
                  <el-select v-model="where.is_payment" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="有缴费记录" value="1"></el-option>
                    <el-option label="无缴费记录" value="0"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">报事报修：</span>
                  <el-select v-model="where.is_repair" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="有报事报修" value="1"></el-option>
                    <el-option label="无报事报修" value="0"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">投诉建议：</span>
                  <el-select v-model="where.is_complaint" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="有投诉" value="1"></el-option>
                    <el-option label="无投诉" value="0"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">认证方式：</span>
                  <el-select v-model="where.is_auto" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="主动认证" value="0"></el-option>
                    <el-option label="自动认证" value="1"></el-option>
                    <el-option label="管家认证" value="2"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">待审批：</span>
                  <el-select v-model="where.status_log" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="search-row">
                <div class="search-item">
                  <span class="search-label">业主拜访：</span>
                  <el-select v-model="where.is_visit" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="有拜访" value="1"></el-option>
                    <el-option label="无拜访" value="0"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">活跃状态：</span>
                  <el-select v-model="where.is_active" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="活跃" value="1"></el-option>
                    <el-option label="不活跃" value="0"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">满意度调查：</span>
                  <el-select v-model="where.is_question" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="有参与" value="1"></el-option>
                    <el-option label="无参与" value="0"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">是否好友：</span>
                  <el-select v-model="where.is_friend" size="mini" clearable placeholder="请选择" style="width: 120px">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">开始日期：</span>
                  <el-date-picker
                    v-model="where.start_time"
                    type="date"
                    placeholder="选择日期"
                    size="mini"
                    style="width: 150px"
                    :disabled-date="(time) => {
                      // 不能选择未来日期
                      if (time.getTime() > Date.now()) {
                        return true;
                      }
                      // 如果选择了结束日期，开始日期不能晚于结束日期-30天
                      if (where.end_time) {
                        const endDate = new Date(where.end_time);
                        const minStartDate = new Date(endDate);
                        minStartDate.setDate(endDate.getDate() - 30);
                        return time.getTime() < minStartDate.getTime();
                      }
                      return false;
                    }"
                  ></el-date-picker>
                </div>
                <div class="search-item">
                  <span class="search-label">结束日期：</span>
                  <el-date-picker
                    v-model="where.end_time"
                    type="date"
                    placeholder="选择日期"
                    size="mini"
                    style="width: 150px"
                    :disabled-date="(time) => {
                      // 不能选择未来日期
                      if (time.getTime() > Date.now()) {
                        return true;
                      }
                      // 如果选择了开始日期，结束日期不能早于开始日期，也不能超过开始日期+30天
                      if (where.start_time) {
                        const startDate = new Date(where.start_time);
                        const maxEndDate = new Date(startDate);
                        maxEndDate.setDate(startDate.getDate() + 30);
                        return time.getTime() < startDate.getTime() || time.getTime() > maxEndDate.getTime();
                      }
                      return false;
                    }"
                  ></el-date-picker>
                </div>
                <div class="search-item">
                  <span class="search-label">房产信息：</span>
                  <el-input v-model="where.house_name"  placeholder="请输入内容"></el-input>
                </div>
                <div class="search-buttons">
                  <el-button type="primary" size="mini" @click="searchList()" style="margin-right: 10px">搜索</el-button>
                  <el-button type="success" size="mini" @click="execl()">导出</el-button>
                </div>
              </div>
            </div>
          </SelectCdjProjectHeader>

        </div>
      </div>
    </div>

    <el-tabs v-model="activeTab" class="fixed-tabs">
      <el-tab-pane label="统计报表" name="report">
        <div class="table-wrap">
          <el-table
            v-loading="loading"
            v-if="pageData" :data="pageDataReport.list"
            border
            :row-style="{ height: '20px', lineHeight: '20px' }"
            style="width: 100%; border: 1px solid #000;"
            height="75vh">
            <el-table-column prop="project_name" label="项目/区域" align="center"></el-table-column>
            <el-table-column prop="house_count" label="房产数" align="center"></el-table-column>
            <el-table-column label="公众号" align="center">
              <el-table-column label="业主" align="center" :header-cell-style="{ background: '#fff9e6' }">
                <el-table-column prop="owner_count" label="数量" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="owner_ratio" label="比例" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="payment_owner_ratio" label="比例(缴费)" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
              </el-table-column>
              <el-table-column label="租户" align="center" :header-cell-style="{ background: '#fff9e6' }">
                <el-table-column prop="tenant_count" label="数量" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="tenant_ratio" label="比例" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="payment_tenant_ratio" label="比例(缴费)" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
              </el-table-column>
              <el-table-column label="住户" align="center" :header-cell-style="{ background: '#fff9e6' }">
                <el-table-column prop="resident_count" label="数量" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="resident_ratio" label="比例" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="payment_resident_ratio" label="比例(缴费)" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
              </el-table-column>
              <el-table-column label="汇总" align="center" :header-cell-style="{ background: '#fff9e6' }">
                <el-table-column prop="total_count" label="数量" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="total_ratio" label="比例" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="payment_owner_total_ratio" label="比例(缴费)" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
              </el-table-column>
              <el-table-column label="活跃度" align="center" :header-cell-style="{ background: '#fff9e6' }">
                <el-table-column prop="payment_ratio" label="缴费人数" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="repair_ratio" label="报事报修人数" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="complaint_ratio" label="投诉人数" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="visit_ratio" label="拜访人数" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="question_ratio" label="满意度调查人数" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
                <el-table-column prop="active_ratio" label="活跃度人数" align="center" :header-cell-style="{ background: '#fff9e6' }"></el-table-column>
              </el-table-column>
            </el-table-column>
            <el-table-column label="企业微信好友" align="center">
              <el-table-column label="业主" align="center">
                <el-table-column prop="friend_owner_count" label="数量" align="center"></el-table-column>
                <el-table-column prop="friend_owner_ratio" label="比例" align="center"></el-table-column>
                <el-table-column prop="payment_friend_owner_ratio" label="比例(缴费)" align="center"></el-table-column>
              </el-table-column>
              <el-table-column label="租户" align="center">
                <el-table-column prop="friend_tenant_count" label="数量" align="center"></el-table-column>
                <el-table-column prop="friend_tenant_ratio" label="比例" align="center"></el-table-column>
                <el-table-column prop="payment_friend_tenant_ratio" label="比例(缴费)" align="center"></el-table-column>
              </el-table-column>
              <el-table-column label="住户" align="center">
                <el-table-column prop="friend_resident_count" label="数量" align="center"></el-table-column>
                <el-table-column prop="friend_resident_ratio" label="比例" align="center"></el-table-column>
                <el-table-column prop="payment_friend_resident_ratio" label="比例(缴费)" align="center"></el-table-column>
              </el-table-column>
              <el-table-column label="汇总" align="center">
                <el-table-column prop="friend_total_count" label="数量" align="center"></el-table-column>
                <el-table-column prop="friend_total_ratio" label="比例" align="center"></el-table-column>
                <el-table-column prop="payment_friend_total_ratio" label="比例(缴费)" align="center"></el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageDataReport.total*1"
                         :page-size="pageDataReport.pageSize*1" :current-page="pageDataReport.page*1"
                         @current-change="pageChangeReport"></el-pagination>
        </div> -->
      </el-tab-pane>
      <el-tab-pane label="数据列表" name="list">
        <div class="table-wrap">
          <div class="count-info" style="margin-bottom: 10px;">
             <el-tag type="danger" effect="dark">业户数量:{{ pageData ? pageData.total : 0 }}</el-tag>
          </div>
          <el-table
            v-loading="loadingList"
            v-if="pageData" :data="pageData.list"
            border
            :row-style="{ height: '20px', lineHeight: '20px' }"
            height="60vh">
            <el-table-column prop="zone_name" label="项目/区域" width="120" fixed="left"></el-table-column>
            <el-table-column prop="project_house_name" label="项目名称" width="180" fixed="left"></el-table-column>
            <el-table-column prop="house_name" label="房产信息" min-width="350" show-overflow-tooltip fixed="left"></el-table-column>
            <el-table-column label="房产类型" width="100" align="center" fixed="left">
              <template slot-scope="scope">
                {{ {
                  1: '住宅',
                  2: '车位'
                }[scope.row.group] || scope.row.group }}
              </template>
            </el-table-column>
            <el-table-column label="房态" width="100" align="center" fixed="left">
              <template slot-scope="scope">
                {{ {
                  1: '空置',
                  2: '未领',
                  3: '空关',
                  4: '装修',
                  5: '入住',
                  6: '出租',
                  7: '停用'
                }[scope.row.house_status] || scope.row.house_status }}
              </template>
            </el-table-column>
            <el-table-column prop="member_nickname" label="微信昵称" width="130"></el-table-column>
            <el-table-column prop="member_telphone" label="微信电话" width="130" align="center"></el-table-column>
            <el-table-column prop="house_telphone" label="房产电话" width="130" align="center"></el-table-column>
            <el-table-column label="业户类型" width="100" align="center">
                <template slot-scope="scope">
                  {{ {
                    1: '业主',
                    2: '租户',
                    3: '住户'
                  }[scope.row.identity] || '' }}
                </template>
            </el-table-column>
            <el-table-column prop="is_effective" label="是否真实业户" width="100" align="center">
              <template slot-scope="scope">
                {{ {
                  0: '否',
                  1: '是'
                }[scope.row.is_effective] || '' }}
              </template>
            </el-table-column>
            <el-table-column label="活动痕迹" width="120" align="center">
              <el-table-column prop="is_payment" label="缴费次数" width="80" align="center"></el-table-column>
              <el-table-column prop="is_repair" label="报事报修" width="80" align="center"></el-table-column>
              <el-table-column prop="is_complaint" label="投诉建议" width="80" align="center"></el-table-column>
              <el-table-column prop="is_visit" label="业主拜访" width="80" align="center"></el-table-column>
              <el-table-column prop="is_question" label="满意度调查" width="100" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="活跃业户" width="80" align="center">
              <template slot-scope="scope">
                {{ {
                  0: '否',
                  1: '是'
                }[scope.row.is_active] || scope.row.is_active }}
              </template>
            </el-table-column>
            <el-table-column label="是否好友" width="100" align="center">
              <template slot-scope="scope">
                {{ scope.row.is_friend > 0 ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="is_auto" label="认证方式" width="100" align="center">
              <template slot-scope="scope">
                {{ {
                  0: '主动认证',
                  1: '自动认证',
                  2: '管家认证'
                }[scope.row.is_auto] || scope.row.is_auto }}
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="认证日期" width="100" align="center"></el-table-column>
            <el-table-column
              label="操作"
              width="100" align="center" fixed="right">
              <template slot-scope="scope">
                <!-- <el-button v-if="ERP.isPermission(1701001001)" type="text" size="small" @click="handleUnbind(scope.row)">解绑</el-button>
                <el-button v-if="ERP.isPermission(1701001002)" type="text" size="small" @click="approvalUnbind(scope.row)">审核</el-button> -->
                <el-button v-if="ERP.isPermission(1701001001) && (scope.row.status_log == 0 || scope.row.status_log == null ) " type="text" size="small" @click="handleUnbind(scope.row)">解绑</el-button>
                <el-button v-if="ERP.isPermission(1701001002) && scope.row.status_log == 1" type="text" size="small" @click="approvalUnbind(scope.row)">待审核</el-button>
              </template>
            </el-table-column>
          </el-table>
                    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange"></el-pagination>
        </div>
        <!-- <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange"></el-pagination>
        </div> -->
      </el-tab-pane>
      <el-tab-pane label="认证审批" name="MemberHouse">
        <MemberHouseReview v-if="activeTab === 'MemberHouse'"></MemberHouseReview>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import moment from "moment/moment";
import ButlerHttp from "./common/ButlerHttp";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeaderNotArea";
import MemberHouseReview from "./components/MemberHouseReview";

export default {
  name: "PropertyBindingList",
  components: {MemberHouseReview, SelectCdjProjectHeader},
  provide() {
    return {
      reginWhere: this.reginWhere
    };
  },
  data(){
    return{
      loading: false,
      loadingList: false,
      activeTab: 'report',
      where: {
        text:"",
        is_authentication:"",
        start_time:moment(new Date()).subtract(30, 'days').format("YYYY-MM-DD"),
        end_time:moment(new Date()).format("YYYY-MM-DD"),
        identity:"",
        is_effective:"",
        is_payment:"",
        is_repair:"",
        is_complaint:"",
        is_visit:"",
        is_active:"",
        is_question:"",
        is_auto:"",
        status_log:"",
        house_name:""
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      pageDataReport: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[]
      },
      countObj:{
        count1:0,
        count2:0
      },
      countObjReport:{
        count1:0,
        count2:0
      }
    }
  },
  computed: {
    tableHeaderStyle() {
      return {
        background: '#f5f7fa',
        fontWeight: 'bold'
      }
    }
  },
  activated() {
    const that=this;
    ERP.isPermission(1701001001)
  },
  methods:{
    searchList(){
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      };
      this.pageDataReport= {
        list: [],
        total: 0,
        pageSize: 1000000,
        page: 1,
      };
      this.getList()
      this.getListReport()
    },
    getList() {
      const that = this;
      that.loadingList = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      //if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      ButlerHttp.get("PropertyBinding/getList", {
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loadingList = false;
      });
    },
    getListReport() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      //if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      ButlerHttp.get("PropertyBinding/getReport", {
        ...where,
        page: that.pageDataReport.page,
        pageSize: that.pageDataReport.pageSize
      }, res => {
        if (res.code) {
          that.pageDataReport = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    pageChangeReport(i) {
      this.pageDataReport.page = i
      this.getListReport()
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;

      that.pageChange(1)
      that.getListReport(1)
    },
    execl(){
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      //if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      ButlerHttp.get("PropertyBinding/getReport", {
        ...where,
        isExcel:true,
      }, res => {
        if (res.code) {
          window.location.href = res.data.file_path;
        }
      });
    },
    handleUnbind(item){
      const that = this;
      that.$prompt('请填写解绑备注', '解绑确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入解绑原因',
        inputValidator: (value) => {
          if (!value || value.trim() === '') {
            return '解绑备注不能为空';
          }
          if (value.length > 200) {
            return '解绑备注不能超过200个字符';
          }
          return true;
        }
      }).then(({ value }) => {
        // 将备注添加到请求参数中
        const params = { ...item, remark: value.trim() };
        ButlerHttp.get("PropertyBinding/delete", params, res => {
          if (res.code) {
            that.$message({
              message: '提交成功',
              type: 'success'
            });
            that.getList();
          }
        });
      }).catch(() => {

      });
    },
    approvalUnbind(item){
      const that = this;
      console.info(item)
      // 构建提示信息，包含备注
      let message = '确定要审核该房产绑定吗？';
      if (item.remark_log) {
        message += `\n\n解绑备注：${item.remark_log}`;
      }
      that.$confirm(message, '审核确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        ButlerHttp.get("PropertyBinding/approval", item, res => {
          if (res.code) {
            that.$message({
              message: '审核成功',
              type: 'success'
            });
            that.getList();
          }
        });
      }).catch(() => {

      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "common";
.content{
  padding: 10px;
  margin-left: 10px;

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .fixed-tabs{
    position: sticky;
    top: 60px;
    left: 0;
    right: 0;
    z-index: 9;
    background-color: #FFFFFF;
    border-bottom: 1px solid #e4e7ed;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
  .search-form{
    background: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 10px;
  }
  .search-row{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }
  .search-row:last-child{
    margin-bottom: 0;
  }
  .search-buttons{
    display: flex;
    align-items: center;
  }
  .search-item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .search-label{
    font-size: 12px;
    color: #606266;
    margin-right: 8px;
    white-space: nowrap;
  }
  .table-wrap{
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
  }
  .el-table{
    overflow-x: auto;
    border: 1px solid #000 !important;
  }
  .el-table th,
  .el-table td {
    border: 1px solid #000 !important;
  }
  .el-table__header-wrapper th {
    border: 1px solid #000 !important;
  }
  .el-table__body-wrapper td {
    border: 1px solid #000 !important;
  }
  .el-table__header-wrapper {
    border-bottom: 1px solid #000 !important;
  }
  .el-table__header-wrapper .el-table__header {
    border: 1px solid #000 !important;
  }
  .el-table__header-wrapper th.el-table__cell {
    border-right: 1px solid #000 !important;
    border-bottom: 1px solid #000 !important;
  }
  .table-header-black {
    border: 1px solid #000 !important;
  }
  .el-table__body-wrapper{
    overflow-y: auto;
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }
  .report-content{
    padding: 20px;
  }
  .statistics-grid{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-top: 20px;
  }
  .stat-item{
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .stat-label{
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }
  .stat-value{
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  .card-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
    >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/PropertyBindingList.vue